<template>
  <div id="app">
    <div class="row">
      <div class="col-md-12" id="selectFilters">
          <form>
            <div class="col-md-3">
                <label class="col-md-12">Document Type:</label>
                <select class="form-control" id="docTypeSelect" name="docType">
                    <option selected>All</option>
                </select>
            </div>
            <div class="col-md-2">
                <label class="col-md-12">Workflow Status:</label>
                <select class="form-control" id="docStatusSelect" name="docStatus">
                    <option selected>In Process</option>
                    <option>Complete</option>
                </select>
            </div>

            </form>
        </div>
    </div>

    <div class="row">
        <div id="documentTable" class="col-md-12">
            <table class="table table-striped table-bordered" id="dataTABLE">
                <thead class="thead-inverse" id="docDataTable">
                    
                </thead>
                <tbody id="docDataList"></tbody>
            </table>
        </div>
    </div>
    <div class="row">
        <div id="messageContainer" class="col-md-12 text-center">

        </div>
    </div>

    <div class="row" id="table-row">
        <div class="col-md-12 table-responsive">
            <table class="table table-striped table-bordered">
                <thead class="thead-inverse" id="itprDB_Table">

                </thead>
                <tbody id="itprList"></tbody>
            </table>
        </div>
    </div>
    <div id="loadingModal" class='modal'></div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientApp/MyForms/App.vue